var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
export var TriangleRightIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { d: "M6.931 4.001c-1.066.003-1.93.89-1.931 1.986v12.027c0 .71.368 1.365.966 1.72a1.886 1.886 0 0 0 1.933-.001l10.135-6.013c.598-.355.966-1.01.966-1.72s-.368-1.365-.966-1.72L7.899 4.267A1.894 1.894 0 0 0 6.934 4l-.003.001z" }))); };
//# sourceMappingURL=TriangleRightIcon.js.map